<script setup lang="ts">
import type { SpotManualItem } from 'types/blocks';

defineProps<{
  spot: SpotManualItem;
}>();
</script>

<template>
  <article class="group relative">
    <BaseScrollTransition
      class="overflow-hidden bg-gray-50"
      content-class="relative overflow-hidden bg-black/75 aspect-video"
    >
      <figure class="overflow-hidden">
        <BaseImage
          v-if="spot?.image?.url"
          class="aspect-video w-full scale-100 object-cover transition-all duration-300 ease-out group-hover:scale-105"
          :image="spot.image"
          :modifiers="{
            mode: 'crop',
            center: `${spot.image.focalPoint?.left},${spot.image.focalPoint?.top}`,
          }"
          :width="550"
          :height="410"
        />
      </figure>
    </BaseScrollTransition>

    <div
      v-if="spot?.spotHeadline || spot?.spotDescription"
      class="mt-4 flex flex-col md:mt-8"
    >
      <h2
        v-if="spot?.spotHeadline"
        class="mb-1 text-h3 font-bold md:mb-4 lg:text-h4"
      >
        {{ spot.spotHeadline }}
      </h2>

      <BaseRte
        v-if="spot?.spotDescription"
        :content="spot.spotDescription"
      />
    </div>

    <UmbracoLink
      v-if="spot?.spotLink?.url"
      :link="spot.spotLink"
      class="!absolute inset-0 !h-full !w-full"
      :aria-label="spot?.spotLink.name"
    />
  </article>
</template>
